import React, { FC, ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const Card: FC<CardProps> = ({ children, className = '', onClick }) => {
  return (
    <div 
      className={`bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl shadow-lg p-6 transition-all duration-300 hover:bg-slate-800/80 hover:border-slate-600 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;